import { useState, useEffect, useMemo } from 'react'
import { css } from '@emotion/css'

interface Styles {
  [key: string]: any
}

interface Theme {
  [key: string]: any
}

const useCustomStyles = (
  styles: Styles | ((theme: Theme, props?: any) => Styles),
  theme: Theme,
  props?: any
) => {
  const [classes, setClasses] = useState<{ [key: string]: string }>({})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedProps = useMemo(() => props, [JSON.stringify(props)])

  useEffect(() => {
    const evaluatedStyles =
      typeof styles === 'function' ? styles(theme, memoizedProps) : styles

    const generated: { [key: string]: string } = {}
    for (const key in evaluatedStyles) {
      if (Object.prototype.hasOwnProperty.call(evaluatedStyles, key)) {
        generated[key] = css(evaluatedStyles[key])
      }
    }

    setClasses(generated)
  }, [styles, theme, memoizedProps])

  return classes
}

export default useCustomStyles
